import { CiCircleList } from 'react-icons/ci';
import { FaBell, FaBirthdayCake, FaBriefcase, FaCalendarAlt, FaCheckCircle, FaCity, FaClock, FaEye, FaFileAlt, FaGlobe, FaGraduationCap, FaHashtag, FaImage, FaKey, FaMapMarkerAlt, FaOrcid, FaRegBuilding, FaTrophy, FaUser, FaUserFriends, FaUserMinus, FaUserPlus, FaUserTie, FaUsers } from 'react-icons/fa';
import { GiBigDiamondRing } from 'react-icons/gi';
import { GoLaw } from 'react-icons/go';
import { IoIosPhonePortrait } from 'react-icons/io';
import { LiaStickyNote } from 'react-icons/lia';
import { MdAbc, MdColorLens, MdGroupWork, MdGroups, MdOutlineAddHomeWork, MdOutlineEditLocationAlt, MdOutlineEmail, MdOutlineLabel, MdOutlinePhoneEnabled, MdRepeat } from 'react-icons/md';
import { PiBuildingOffice } from 'react-icons/pi';
import { RiIdCardLine } from 'react-icons/ri';
import { TbNumber, TbPencilQuestion } from 'react-icons/tb';
import { VscReplaceAll } from 'react-icons/vsc';

const iconSize = 24;

/**
 * Nomes descritivos para os campos.
 */
export enum FieldKeys {
  CPF = 'CPF',
  EMAIL = 'EMAIL',
  DATA_NASCIMENTO = 'DATA_NASCIMENTO',
  DATA_ADMISSAO = 'DATA_ADMISSAO',
  DATA_EXONERACAO = 'DATA_EXONERACAO',
  DATA_REFERENCIA = 'DATA_REFERENCIA',
  DATA_ENTRADA = 'DATA_ENTRADA',
  DATA_SAIDA = 'DATA_SAIDA',
  CRIADO_EM = 'CRIADO_EM',
  EDITADO_EM = 'EDITADO_EM',
}

/**
 * Mapeamento entre nomes descritivos e os números.
 */
const fieldMap: Record<FieldKeys, number> = {
  [FieldKeys.CPF]: 0,
  [FieldKeys.EMAIL]: 1,
  [FieldKeys.DATA_NASCIMENTO]: 2,
  [FieldKeys.DATA_ADMISSAO]: 3,
  [FieldKeys.DATA_EXONERACAO]: 4,
  [FieldKeys.DATA_REFERENCIA]: 5,
  [FieldKeys.DATA_ENTRADA]: 13,
  [FieldKeys.DATA_SAIDA]: 14,
  [FieldKeys.CRIADO_EM]: 23,
  [FieldKeys.EDITADO_EM]: 25,
};

/**
 * Lista de campos de data usando os nomes descritivos.
 */
export const dateFields = [
  fieldMap.DATA_NASCIMENTO,
  fieldMap.DATA_ADMISSAO,
  fieldMap.DATA_EXONERACAO,
  fieldMap.DATA_REFERENCIA,
  fieldMap.DATA_ENTRADA,
  fieldMap.DATA_SAIDA,
  fieldMap.CRIADO_EM,
  fieldMap.EDITADO_EM,
];

/**
 * Mapeamento de ícones para campos de histórico.
 */
export const iconMap: Record<number, JSX.Element> = {
  0: <RiIdCardLine size={iconSize} title="CPF" />,
  1: <MdOutlineEmail size={iconSize} title="E-mail" />,
  2: <FaBirthdayCake size={iconSize} title="Data de Nascimento" />,
  3: <FaUserPlus size={iconSize} title="Data de Admissão" />,
  4: <FaUserMinus size={iconSize} title="Data de Exoneração" />,
  5: <FaCalendarAlt size={iconSize} title="Data de Referência" />,
  6: <VscReplaceAll size={iconSize} title="Nome" />,
  7: <FaUserTie size={iconSize} title="Título" />,
  8: <FaCheckCircle size={iconSize} title="Ativo" />,
  9: <LiaStickyNote size={iconSize} title="Anotação" />,
  10: <GiBigDiamondRing size={iconSize} title="Estado Civil" />,
  11: <MdOutlinePhoneEnabled size={iconSize} title="Telefone" />,
  12: <IoIosPhonePortrait size={iconSize} title="Celular" />,
  13: <FaCalendarAlt size={iconSize} title="Data de Entrada" color="green" />,
  14: <FaCalendarAlt size={iconSize} title="Data de Saída" color="red" />,
  15: <FaRegBuilding size={iconSize} title="Prédio ID" />,
  16: <PiBuildingOffice size={iconSize} title="Comarca ID" />,
  17: <FaUserFriends size={iconSize} title="1ª Substituta" />,
  18: <FaUsers size={iconSize} title="2ª Substituta" />,
  19: <CiCircleList size={iconSize} title="Ordem" />,
  20: <GoLaw size={iconSize} title="Vara" />,
  21: <FaCalendarAlt size={iconSize} title="Setor" />,
  22: <FaOrcid size={iconSize} title="ID" />,
  23: <FaCalendarAlt size={iconSize} title="Criado em" />,
  24: <FaUser size={iconSize} title="Criado por" color="green" />,
  25: <FaCalendarAlt size={iconSize} title="Editado em" />,
  26: <FaUser size={iconSize} title="Editado por" />,
  27: <FaMapMarkerAlt size={iconSize} title="Endereço" />,
  28: <MdGroups size={iconSize} title="Máximo de Estagiários" color="white" />,
  29: <MdGroups size={iconSize} title="Máximo de Integrantes" color="green" />,
  30: <CiCircleList size={iconSize} title="Agrupar" />,
  31: <MdOutlineLabel size={iconSize} title="Prefixo" />,
  32: <GoLaw size={iconSize} title="Defensoria" />,
  33: <MdOutlinePhoneEnabled size={iconSize} title="Telefones" />,
  34: <GoLaw size={iconSize} title="Atuação" />,
  35: <FaRegBuilding size={iconSize} title="CNPJ" />,
  36: <FaRegBuilding size={iconSize} title="Razão Social" />,
  37: <FaUser size={iconSize} title="Representante Nome" />,
  38: <FaUserTie size={iconSize} title="Representante Cargo" />,
  39: <MdOutlineAddHomeWork size={iconSize} title="Bairro" />,
  40: <FaHashtag size={iconSize} title="CEP" />,
  41: <FaCity size={iconSize} title="Cidade" />,
  42: <MdOutlineEditLocationAlt size={iconSize} title="Complemento" />,
  43: <FaMapMarkerAlt size={iconSize} title="Logradouro" />,
  44: <TbNumber size={iconSize} title="Número" />,
  45: <TbNumber size={iconSize} title="DDD" color="red" />,
  46: <MdAbc size={iconSize} title="Sigla" />,
  47: <MdGroupWork size={iconSize} title="Capacidade" color="red" />,
  48: <FaCheckCircle size={iconSize} title="Status" />,
  49: <FaClock size={iconSize} title="Horário de Entrada" color="green" />,
  50: <FaClock size={iconSize} title="Horário de Saída" color="red" />,
  51: <LiaStickyNote size={iconSize} title="Anotação 1" />,
  52: <LiaStickyNote size={iconSize} title="Anotação 2" />,
  53: <FaUserTie size={iconSize} title="Assessor" />,
  54: <FaCheckCircle size={iconSize} title="Ativa" />,
  55: <FaFileAlt size={iconSize} title="Ativo no Relatório" />,
  56: <GoLaw size={iconSize} title="Atuação" />,
  57: <MdOutlineLabel size={iconSize} title="Categoria" />,
  58: <GoLaw size={iconSize} title="Cível" />,
  59: <FaHashtag size={iconSize} title="Código" />,
  60: <FaUser size={iconSize} title="Colaborador" />,
  61: <MdColorLens size={iconSize} title="Cor de Fundo" />,
  62: <MdColorLens size={iconSize} title="Cor da Letra" />,
  63: <GoLaw size={iconSize} title="Criminal" />,
  64: <FaGraduationCap size={iconSize} title="Curso" />,
  65: <FaCalendarAlt size={iconSize} title="Data Aquisitiva" />,
  66: <FaGraduationCap size={iconSize} title="Colação de Grau" />,
  67: <FaCalendarAlt size={iconSize} title="Fim do Estágio" color="red" />,
  68: <FaCalendarAlt size={iconSize} title="Início do Estágio" color="green" />,
  69: <FaCalendarAlt size={iconSize} title="Data Final" color="red" />,
  70: <FaCalendarAlt size={iconSize} title="Data Inicial" color="green" />,
  71: <FaCalendarAlt size={iconSize} title="Data de Recebimento" />,
  72: <FaCalendarAlt size={iconSize} title="Data de Recuperação" />,
  73: <FaUserTie size={iconSize} title="Defensor" />,
  74: <MdAbc size={iconSize} title="Descrição" />,
  75: <FaUserMinus size={iconSize} title="Desligamento" />,
  76: <FaCalendarAlt size={iconSize} title="Dias Livres" />,
  77: <FaUserTie size={iconSize} title="Diretor" />,
  78: <FaRegBuilding size={iconSize} title="Diretoria" />,
  79: <FaMapMarkerAlt size={iconSize} title="Distrito" />,
  80: <MdOutlineEmail size={iconSize} title="E-mail Institucional" />,
  81: <MdOutlineEmail size={iconSize} title="E-mail Pessoal" />,
  82: <FaClock size={iconSize} title="Entrada" color="green" />,
  83: <FaUser size={iconSize} title="Estagiário" />,
  84: <FaGraduationCap size={iconSize} title="Estágio" />,
  85: <FaEye size={iconSize} title="Exibir Anotação" />,
  86: <FaEye size={iconSize} title="Exibir Relatório" />,
  87: <FaClock size={iconSize} title="Fim" color="red" />,
  88: <FaClock size={iconSize} title="Início" color="green" />,
  89: <FaCalendarAlt size={iconSize} title="Fim de Semana" />,
  90: <FaImage size={iconSize} title="Foto" />,
  91: <FaBriefcase size={iconSize} title="Função" />,
  92: <FaGlobe size={iconSize} title="Geral" />,
  93: <FaGraduationCap size={iconSize} title="Instituição de Ensino" />,
  94: <FaRegBuilding size={iconSize} title="Interno" />,
  95: <FaKey size={iconSize} title="Login por Senha" />,
  96: <FaKey size={iconSize} title="Login por Token" />,
  97: <RiIdCardLine size={iconSize} title="Matrícula" />,
  98: <MdGroups size={iconSize} title="Máximo de Membros" />,
  99: <LiaStickyNote size={iconSize} title="Motivo" />,
  101: <MdGroups size={iconSize} title="Núcleo" />,
  102: <TbNumber size={iconSize} title="Número de Lançamento" />,
  103: <RiIdCardLine size={iconSize} title="OAB" />,
  104: <LiaStickyNote size={iconSize} title="Observação" />,
  105: <FaUser size={iconSize} title="Registro Pai" />,
  106: <FaUserTie size={iconSize} title="Papel" />,
  107: <FaUser size={iconSize} title="Pessoa" />,
  108: <FaCheckCircle size={iconSize} title="Pode ser Responsável" />,
  109: <FaTrophy size={iconSize} title="Pontuar" />,
  110: <FaFileAlt size={iconSize} title="Portaria" />,
  111: <TbPencilQuestion size={iconSize} title="Rascunho" />,
  112: <FaBell size={iconSize} title="Recebe Notificações" />,
  113: <FaCalendarAlt size={iconSize} title="Referência" />,
  114: <FaCheckCircle size={iconSize} title="Relatórios de Atividades" />,
  115: <FaCalendarAlt size={iconSize} title="Relatórios habilitados em" />,
  116: <MdRepeat size={iconSize} title="Repete Anualmente" />,
  117: <FaFileAlt size={iconSize} title="Resolução" />,
  118: <FaUserTie size={iconSize} title="Responsável" />,
  119: <FaClock size={iconSize} title="Saída" color="red" />,
  120: <VscReplaceAll size={iconSize} title="Sobrenome" />,
  121: <MdOutlineLabel size={iconSize} title="Tipo" />,
  122: <MdOutlineLabel size={iconSize} title="Tipo de Estágio" />,
  123: <FaClock size={iconSize} title="Último Login" />,
  124: <FaUser size={iconSize} title="Usuário" />,
  125: <FaEye size={iconSize} title="Visão" />,
  100: <TbPencilQuestion size={iconSize} title="Histórico vazio" />,
};
